import { generateSearchParams } from '@/utils/generateSearchParams';
import { request } from '@/utils/request';
import { ResponseBasis, ResponseWithSeo } from '@/api/api.types';
import { PromotionItem, PromotionsListOptions } from '@/api/promotions/promotions.types';

export async function getPromotionsList(options: PromotionsListOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<PromotionItem>>(`/promotion/?${searchParams.toString()}`);
}

export async function getCurrentPromotion({ id }: { id: number }) {
  return request<PromotionItem & ResponseWithSeo>(`/promotion/${id}/`);
}

export async function getCurrentPromotionBySlug({ slug }: { slug: string }) {
  return request<PromotionItem & ResponseWithSeo>(`/promotion/slug/${slug}/`);
}